@if (url) {
  <div
    class="d-flex flex-column flex-md-column gap-s align-items-center justify-content-space-between"
  >
    <div class="img-docs">
      <img
        src="assets/img/downloadDocs-simu.png"
        width="117px"
        height="93px"
        alt=""
      />
    </div>
    <pr-button
      clazz="full-w"
      size="lg"
      icon="download"
      label="Téléchargez les documents utiles"
      display="neutral"
      (onClick)="downloadDocs()"
    ></pr-button>
  </div>
}
